
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13.378","height":"15.608"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.892 15.608A.892.892 0 010 14.716V.892a.892.892 0 011.784 0v13.824a.892.892 0 01-.892.892z","fill":"#8899a6"}}),_c('path',{attrs:{"d":"M.892 0A.892.892 0 000 .892v13.824a.223.223 0 00.446 0V1.522a.631.631 0 01.631-.631h.707A.892.892 0 00.892 0z","fill":"#aab8c2"}}),_c('path',{attrs:{"d":"M.892 15.608A.892.892 0 010 14.716V.892a.892.892 0 011.784 0v13.824a.892.892 0 01-.892.892z","fill":"#8899a6"}}),_c('path',{attrs:{"d":"M.892 0A.892.892 0 000 .892v13.824a.223.223 0 00.446 0V1.522a.631.631 0 01.631-.631h.707A.892.892 0 00.892 0z","fill":"#aab8c2"}}),_c('path',{attrs:{"d":"M13.109.928a6.218 6.218 0 00-2.406-.494l-.613.169-2.062.288-.446-.057-.317.067a16.778 16.778 0 01-2.8.438l-.446.444-2.681-.446V9.81h2.676l.446.892h.034a17.729 17.729 0 002.958-.456l.129-.027.288-.288 2.425-.316.408.183a5.351 5.351 0 012.053.421.446.446 0 00.623-.409V1.337a.446.446 0 00-.269-.409z","fill":"#31373d"}}),_c('path',{attrs:{"d":"M4.46 1.34c-.107 0-.213.016-.32.016A5.39 5.39 0 011.961.929a.446.446 0 00-.623.409v2.676a12.084 12.084 0 003.122.446zm3.122 2.674a14.336 14.336 0 01-3.122.446v3.122a15.823 15.823 0 003.122-.446zm3.121-.446V.435c-.043 0-.083-.006-.126-.006a14.44 14.44 0 00-3 .406v3.179a8.17 8.17 0 013.126-.446zm-9.1 6.653a6.137 6.137 0 002.149.483h.7V7.582a10.27 10.27 0 01-3.114-.446v2.676a.446.446 0 00.269.409zm5.974-3.085v3.084a14.32 14.32 0 013-.426c.043 0 .083 0 .126.006V6.69a9.155 9.155 0 00-3.122.446zm3.122-.446a8.579 8.579 0 012.676.425V3.968a8.57 8.57 0 00-2.676-.4z","fill":"#e1e8ed"}})])
          )
        }
      }
    